import { ConfirmModal, Input } from "@wexinc/wex-ui";
import { useState } from "react";

interface Props {
  onOK: () => void;
  onCancel: () => void;
}

const DeleteOrganizationConfirmModal: React.FC<Props> = (props) => {
  const { onOK, onCancel } = props;
  const [deleteConfirm, setDeleteConfirm] = useState<string>();

  return (
    <ConfirmModal
      onOk={onOK}
      okButtonText="Delete"
      okButtonDisabled={deleteConfirm !== "DELETE"}
      onCancel={onCancel}
      title="Delete organization"
      modalClassNames="max-w-[560px]"
      mode="critical"
    >
      <>
        <label className="font-bold block mb-1">Are you sure you want to delete this organization?</label>
        <p>This will remove all members from the organization and delete any sub-orgs.</p>
        <p>This will also delete any associated SLA dashboards.</p>
        <p className="my-4">Type ‘DELETE’ to confirm</p>
        <Input
          containerClassName="w-1/2"
          name="confirm-delete"
          onChange={(e) => setDeleteConfirm(e.currentTarget.value)}
        />
      </>
    </ConfirmModal>
  );
};

export default DeleteOrganizationConfirmModal;
